module.exports = "/images/vendor/flag-icon-css/flags/4x3/sz.svg?cfb8269f38d55f7f388bca2ae6d18fb4";